export const MgmRedeemCodePageResources = {
  title: "Użyj <b>kodu</b>",

  description: "Jeśli otrzymałeś kod goodie, <b>wprowadź go poniżej.</b>",

  codePlaceholder: "Podaj kod",

  nextButtonText: "Dalej",

  codeInputRequiredMessage: "Wprowadź poprawny kod goodie",
};
